import styled from 'styled-components'
import { Centralizer } from '../../component/container'

export const CentralizerContainer = styled(Centralizer)`
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  background-image: url(/img/background.jpeg);
`
